import axios from "axios";
import { authStore } from "./store/authStore";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// REQUEST
instance.interceptors.request.use(
  (config) => {
    if (!navigator.onLine) {
      return Promise.reject({ message: "No Internet Connection" });
    }

    let jwtToken = JSON.parse(localStorage.getItem("AuthToken"));
    if (jwtToken) {
      config.headers["Authorization"] = `Bearer ${jwtToken}`;
    }

    let userId = JSON.parse(localStorage.getItem("School_id"));
    let schoolCode = localStorage.getItem("schoolCode");

    if (userId && schoolCode) {
      config.headers["X-User-ID"] = schoolCode + "_" + userId;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

const isLoginPage = () => window.location.pathname === "/";

// ✅ RESPONSE (IMPORTANT)
instance.interceptors.response.use(
  (res) => res,
  (error) => {
    if (isLoginPage()) {
      return Promise.reject(error);
    }

    if (error.response?.status === 401) {
      authStore.triggerSessionExpired(); // 🔥 open dialog
    }
    return Promise.reject(error);
  },
);

export default instance;
